<template>
  <div>
    <Header />
    <section class="section-b-space mt90 full-content">
      <div class="w-90 d-flex flex-column align-items-center justify-content-center">
        <h2 class="text-center register-title mb-0"> My Rewards</h2>
        <h5 class="text-center coupon-text mb-4">My Code: <span class="coupon-code">{{rewards_data.data.couponcode}}</span></h5>
        <p class="text-center mb-4" style="max-width: 250px">Share your code with a friend to get a joint for a penny!<p>
        <h5>You've Earned {{rewards_data.data.referrals}} joints!</h5>
        <template v-if="rewards_data.details">
          <table class="coupon-table">
            <tr v-for="details in rewards_data.details" :key="details.index" >
              <td>
                <div>{{details.ref_name}}</div>
              </td>
              <td>
                <div>Claimed on {{details.reg_date}}</div>
              </td>
              <!--
              <td v-if="details.delivered === 1">
                <div> delivered {{details.del_date}}</div>
              </td>
              -->
            </tr>
          </table>
        </template>
        <template v-else>
          <h5>No referrals yet.</h5>
        </template>
      </div>
    </section>
    <Footer />
  </div>
</template>

<script>
import Header from "../../components/header";
import Footer from "../../components/footer";

import { mapGetters } from "vuex";

export default {
  components: {
    Header,
    Footer
  },
  computed: {
    ...mapGetters({
      rewards_data: 'auth/getRewardsData',
    })
  },
  data() {
    return {
    }
  },
  mounted() {
    this.$store.dispatch('auth/loadRewardsData');
  },
  methods: {
  }
}
</script>
